<div class="blog-container">
    <div class="header-container">
        <app-header [theme]="'transparent'"></app-header>
        <div>
            <p class="first-p">{{'Blog'| translate}}</p>
            <p class="second-p">{{'blog-text-one'|translate}}</p>
            <p class="second-p"> {{'blog-text-two'|translate}} </p>
            <div class="search-container">
                <input type="text" class="search-box" placeholder="Search...." (keyup)="search($event)">
                <span class="search-icon-container"> <i class="fa fa-search" aria-hidden="true"></i> </span>
            </div>
        </div>
    </div>

    <div class="all-blog-items-container">
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-12" *ngFor="let blog of AllBlogs | paginate: { itemsPerPage: 6, currentPage: p }">
            <div class="blog-element">
              <div class="blog-img-container">
                <img [src]="blog.image_url">
              </div>
              <div class="m-4">
                  <p class="blog-title"> {{blog.title}} </p>
                  <p class="blog-date"> {{blog.date}} </p>
                  <p class="blog-clamped">
                      {{blog.summary}}
                      <span>....</span>
                  </p>
                  <a class="blog-readMore" routerLink="/blog/{{blog.name}}"> Read More</a>
              </div>
            </div>
          </div>
        </div>
      </div>
        <pagination-controls class="paginator-container" (pageChange)="p = $event"></pagination-controls>
    </div>
    <app-subscribe></app-subscribe>
    <app-footer></app-footer>
</div>